<template>
    <router-link :to="link" class="preview">
        <h2 v-text="title"></h2>
        <span class="date" v-text="publishedDate"></span>
        <img :src="imgUrl" alt="">
        <div class="excerpt" v-html="excerpt"></div>
    </router-link>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "BetanoMagPreview",
        props: {
            mag: { required: true },
        },
        computed: {
            publishedDate() {
                if( this.betanoMag == null ) {
                    return null
                }
                let d = moment(this.betanoMag.date)
                return d.format("DD MMM YYYY")
            },
            betanoMag() {
                return this.$store.getters['betanomag/id'](this.mag.id)
            },
            excerpt() {
                if( this.betanoMag == null ) {
                    return ""
                }
                return this.betanoMag.excerpt.rendered
            },
            imgUrl() {
                if( this.betanoMag == null ) {
                    return ""
                }
                return this.betanoMag.images.medium
            },
            link() {
                if( this.betanoMag == null ) {
                    return ""
                }
                return {
                    name: 'betano-mag',
                    params: {slug: this.betanoMag.slug},
                }
            },
            title() {
                return this.mag.title
            },
        },
        watch: {
            betanoMag: {
                immediate: true,
                handler() {
                    if( this.betanoMag != null ) {
                        return
                    }
                    this.$store.dispatch('betanomag/getOne', {id: this.mag.id})
                },
            },
        },
    }
</script>

<style scoped lang="scss">
.preview {
    display: grid;
    grid-template-columns: 1fr min-content;
    grid-template-rows: min-content min-content 1fr;
    grid-template-areas: 
        "title img"
        "date img"
        "excerpt img"
        ;

    h2 {
        grid-area: title;
        margin: 0;
    }

    img {
        grid-area: img;
        height: 12rem;
        width: 8rem;
    }

    span {
        grid-area: date;
        margin-bottom: .5em;
        font-size: .9rem;
    }

    .excerpt {
        grid-area: excerpt;
    }
}
</style>
